import {MutationTree} from "vuex";
import {ProfilesState} from "@share/profile/store/ProfilesState";
import {UserProfile} from "@api/models/UserProfile";
import Vue from 'vue';

export const mutations: MutationTree<ProfilesState> = {
    addUser(state, user: UserProfile) {
        if (user.userId) {
            Vue.set(state.list, user.userId, user);
        }
    }
}